import { useMemo } from 'react';

import { useBizyGlobalChat } from '../../bizy-widget/hooks/use-bizy-global-chat';
import { useBizyPageContextStore } from '../store/use-bizy-page-context-store';

export function useBizySidePanelChat() {
	const context = useBizyPageContextStore((state) => state.context);

	const extraContext = useMemo(() => {
		return {
			bizy_page_name: context.pageName,
			bizy_page_type: context.pageType,
			...(context.pageData || {}),
		};
	}, [context.pageData, context.pageName, context.pageType]);

	return useBizyGlobalChat({ extraContext });
}
